/* eslint-disable no-console */
/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import Lodash from 'lodash';
import { useHistory } from 'react-router-dom';
import { useJwt } from 'react-jwt';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import { Grid, Button, Divider } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import Paper from '@material-ui/core/Paper';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import SaveIcon from '@material-ui/icons/Save';
import CircularProgress from '@material-ui/core/CircularProgress';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

import { Formik, Field } from 'formik';
import {
  PlnInput,
  PlnDropdown,
} from '../../Components/Input';
import PLNDialog from '../../Components/PLNDialog/PLNDialog';

import useStyles from './styles';
import { searchByCedula } from '../../Core/Api/padronApi';
import {
  getDistritoByTwo,
  useProvincias,
  getCantonsByProvince,
} from '../../Core/Api/locationApi';
import miembrosMesaApi from '../../Core/Api/miembrosMesaApi';
import Consts from '../../Core/Consts/Consts';
import Copyright from '../Copyright/Copyright';
import Storage from '../../Storage/Storage';

import { useMiembrosMesaAvailable } from '../../Core/Api/periodoApi';

const Transition = React.forwardRef(function Transition(
  tProps,
  ref,
) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Slide direction="up" ref={ref} {...tProps} />;
});

const AddMiembro = () => {
  const classes = useStyles();
  const history = useHistory();
  const { data } = useProvincias();

  const validationSchema = Yup.object({});

  // Se valida si esta habilitada la opcion (Agregar Miembro Mesa)
  const isMiembrosMesaAvailable =
    useMiembrosMesaAvailable(19);
  const miembrosMesaAvailable = Lodash.get(
    isMiembrosMesaAvailable,
    ['data', 'response'],
    null,
  );  

  const tokenData = Storage.instance;
  const { decodedToken } = useJwt(tokenData.getToken());
  
  const defaultData = {
    primerApellido: '',
    segundoApellido: '',
    nombre: '',
    celular: '',
    email: '',
    provincia: 9,
    canton: 999,
    distrito: 999,
    jrv: '',
    role: '',
    codProvincia: 0,
    codCanton: 0,
  };

  const [cantones, setCantones] = useState([
    { itemLabel: '- SELECCIONE EL CANTÓN-', value: 999 },
  ]);

  const [distritos, setDistritos] = useState([
    { itemLabel: '- SELECCIONE EL DISTRITO -', value: 999 },
  ]);

  const [jrv, setJRV] = useState([
    { itemLabel: '- Seleccione la JRV -', value: 999 },
  ]);

  const [roles, setRoles] = useState([
    { itemLabel: '- Seleccione un Puesto -', value: 999 },
  ]);

  const [initialValues, setInitialValues] = useState({
    cedula: '',
    celular: '',
    email: '',
    provincia: 9,
    canton: 999,
    distrito: 999,
    jrv: 999,
    role: 999,
  });

  const [sProvincia, setSProvincia] = useState({ value: 9 });
  const [sCanton, setSCanton] = useState({ value: 999 });
  // eslint-disable-next-line no-unused-vars
  const [sDistrito, setSDistrito] = useState(999);
  const provincias = Lodash.get(
    data,
    ['frmOptions'],
    [
      {
        itemLabel: '- SELECCIONE LA PROVINCIA -',
        value: 9,
      },
    ],
  );
  const setProvincia = p => {
    setCantones([
      {
        itemLabel: '- SELECCIONE EL CANTÓN-',
        value: 999,
      },
    ]);
    setDistritos([
      {
        itemLabel: '- SELECCIONE EL DISTRITO-',
        value: 999,
      },
    ]);
    setJRV([
      {
        itemLabel: '- Seleccione la JRV -',
        value: 999,
      },
    ]);
    initialValues.provincia = p;
    initialValues.canton = 999;
    initialValues.distrito = 999;
    if (p !== 9) {
      getCantonsByProvince(p).then(result => {
        if (result.status === 200) {
          const cantonsList = Lodash.get(result, [
            'data',
            'response',
          ]);
          const clist = cantonsList.map(
            ({ cod_canton, des_nombre_c }) => {
              return {
                itemLabel: des_nombre_c,
                value: cod_canton,
              };
            },
          );
          clist.unshift({
            itemLabel: '- SELECCIONE EL CANTÓN-',
            value: 999,
          });
          setSProvincia(
            Lodash.find(provincias, {
              value: p,
            }),
          );
          setCantones(clist);
        }
      });
    } else {
      setCantones([
        {
          itemLabel: '- SELECCIONE EL CANTÓN-',
          value: 999,
        },
      ]);
    }
  };
  const setCanton = c => {
    initialValues.distrito = 999;
    initialValues.provincia = sProvincia.value;
    initialValues.canton = c;
    setJRV([
      {
        itemLabel: '- Seleccione la JRV -',
        value: 999,
      },
    ]);
    if (c !== 999) {
      getDistritoByTwo(sProvincia.value, c).then(result => {
        if (result.status === 200) {
          const distritosList = Lodash.get(result, [
            'data',
            'response',
          ]);
          const dlist = distritosList.map(
            ({ cod_distrito, des_nombre_d }) => {
              return {
                itemLabel: des_nombre_d,
                value: cod_distrito,
              };
            },
          );
          dlist.unshift({
            itemLabel: '- SELECCIONE EL DISTRITO-',
            value: 999,
          });
          setSCanton(
            Lodash.find(cantones, {
              value: c,
            }),
          );
          setDistritos(dlist);
        }
      });
    } else {
      setDistritos([
        {
          itemLabel: '- SELECCIONE EL DISTRITO-',
          value: 999,
        },
      ]);
    }
  };

  const [searchBtnEnabled, setBtnSearch] = useState(false);
  const [searchBtnLabel, setBtnLabel] = useState('Buscar');

  const [showForm, setShowForm] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [open, setOpenDialog] = React.useState(false);

  // eslint-disable-next-line no-unused-vars
  const [memberId, setMemberId] = useState('');
  const [userLogged, setUser] = useState([]);
  const [memberInfo, setMemberInfo] = useState(defaultData);
  const [isNewMemberValid, setIsValidMember] = useState(
    true,
  );
  const [validMemberMsj, setMemberMsj] = useState('');

  const [open2, setOpenDialog2] = React.useState(false);
  const [msjDialog, setMsjDialog] = useState('');
  const handleClose = () => {
    setOpenDialog2(false);
  };

  /**
   * Get Distrits using Prov and Cant
   * @param {*} _provId
   * @param {*} _cantId
   */
  // eslint-disable-next-line no-unused-vars
  const getDistritos = async (_provId, _cantId) => {
    if (_provId && _cantId) {
      await getDistritoByTwo(_provId, _cantId).then(
        _res => {
          const listDistr = _res.data.response;

          if (listDistr instanceof Array) {
            const dlist = listDistr.map(
              // eslint-disable-next-line camelcase
              ({ cod_distrito, des_nombre_d }) => {
                return {
                  itemLabel: des_nombre_d,
                  value: cod_distrito,
                };
              },
            );
            dlist.unshift({
              itemLabel: '- SELECCIONE EL DISTRITO -',
              value: 999,
            });

            setDistritos(dlist);
          }
        },
      );
    }
  };

  const getJRVSelected = _jrv => {
    const currentJRV = parseInt(_jrv, 10);

    if (currentJRV > 0 && currentJRV !== 999) {
      // setJRV(currentJRV);
      console.log(currentJRV);
    }
  };

  const getRoleSelected = _codRole => {
    const currentRole = parseInt(_codRole, 10);

    if (currentRole > 0 && currentRole !== 999) {
      // setRoles(currentJRV);
      console.log(currentRole);
    }
  };

  const getJRV = async _codDistr => {
    setSDistrito(
      Lodash.find(distritos, {
        value: _codDistr,
      }),
    );
    const currentDistr = parseInt(_codDistr, 10);
    
    // Usar directamente los valores del token o de initialValues si sProvincia/sCanton son undefined
    const provinciaValue = sProvincia?.value || sProvincia || initialValues.provincia;
    const cantonValue = sCanton?.value || sCanton || initialValues.canton;
    
    console.log('Provincia value:', provinciaValue);
    console.log('Canton value:', cantonValue);
    
    if (currentDistr > 0 && currentDistr !== 999) {
      await miembrosMesaApi
        .getJuntaReceptora(
          provinciaValue,
          cantonValue,
          currentDistr,
        )
        .then(_res => {
          const listJRV = _res.data.response;
          if (listJRV instanceof Array) {
            const jrvlist = listJRV.map(
              // eslint-disable-next-line camelcase
              // eslint-disable-next-line no-unused-vars
              ({ num_jvirt, index }) => {
                return {
                  itemLabel: `Nº ${num_jvirt}`,
                  value: num_jvirt,
                };
              },
            );
            jrvlist.unshift({
              itemLabel: '- Seleccione la JRV -',
              value: 999,
            });

            setJRV(jrvlist);
          }
        });
    }
  };

  const buildRolesDropdown = () => {
    if (Consts.puestosMesa.length > 0) {
      const rolesList = Consts.puestosMesa.map(
        ({ codigo, descripcion }) => {
          return {
            itemLabel: descripcion,
            value: codigo,
          };
        },
      );

      rolesList.unshift({
        itemLabel: '- Seleccione un Puesto -',
        value: 999,
      });

      setRoles(rolesList);
    }
  };

  /**
   * Search member info using ced
   */
  const getDataByCed = async _form => {
    const { cedula } = _form.values;

    if (cedula) {
      setMemberInfo(defaultData);
      setMemberId(cedula);
      setBtnSearch(true);
      setBtnLabel('Buscando...');
      setShowForm(false);

      const validateMemberResponse = await miembrosMesaApi.validateMemberOnAdd(
        cedula,
      );

      if (
        validateMemberResponse.status === 200 &&
        validateMemberResponse.data.response === 1
      ) {
        setIsValidMember(false);
        setMemberMsj(
          // eslint-disable-next-line max-len
          `Esta persona ya está registrada como ${validateMemberResponse.data.tRegistered} en la JRV Nº ${validateMemberResponse.data.nMesa}, favor corregir`,
        );
      } else {
        setIsValidMember(true);
        setMemberMsj(``);
        await searchByCedula(cedula).then(_response => {
          const info = _response.data.response;

          if (info instanceof Array) {
            setShowForm(true);
            setMemberInfo({
              primerApellido: info[0].des_apell1,
              segundoApellido: info[0].des_apell2,
              nombre: info[0].des_nombre,
              celular: info[0].tel_celu || '',
              email: info[0].des_email || '',
              provincia: 9,
              canton: 999,
              distrito: 999,
              jrv: info[0].num_jvirt,
              role: '',
              codProvincia: info[0].cod_prov,
              codCanton: info[0].cod_cant,
            });

            _form.setFieldValue(
              'celular',
              info[0].tel_celu || '',
            );

            _form.setFieldValue(
              'email',
              info[0].des_email || '',
            );

            _form.setFieldValue('provincia', decodedToken.cod_provincia);
            
            // Cargar cantones automáticamente si hay provincia del token
            if (decodedToken.cod_provincia && decodedToken.cod_provincia !== 9) {
              setProvincia(decodedToken.cod_provincia);
              
              // Establecer cantón del token después de cargar cantones
              if (decodedToken.cod_canton) {
                setTimeout(() => {
                  _form.setFieldValue('canton', decodedToken.cod_canton);
                  setSCanton({ value: decodedToken.cod_canton });
                  
                  // Cargar distritos automáticamente después de establecer cantón
                  getDistritoByTwo(decodedToken.cod_provincia, decodedToken.cod_canton).then(distResult => {
                    if (distResult.status === 200) {
                      const distritosList = Lodash.get(distResult, [
                        'data',
                        'response',
                      ]);
                      const dlist = distritosList.map(
                        ({ cod_distrito, des_nombre_d }) => {
                          return {
                            itemLabel: des_nombre_d,
                            value: cod_distrito,
                          };
                        },
                      );
                      dlist.unshift({
                        itemLabel: '- SELECCIONE EL DISTRITO-',
                        value: 999,
                      });
                      setDistritos(dlist);
                    }
                  });
                }, 100);
              }
            } else {
              setSProvincia(
                Lodash.find(provincias, {
                  value: decodedToken.cod_provincia || 9,
                }),
              );
            }
          } else {
            setShowForm(false);
          }
        });
      }

      setBtnSearch(false);
      setBtnLabel('Buscar');
    }
  };

  /**
   * Save Member
   * @param {*} values
   */
  const saveMember = values => {
    setIsSaving(true);

    const memberData = {
      ind_tendencia: userLogged.cod_tendencia,
      cod_provincia: parseInt(values.provincia, 10),
      cod_canton: parseInt(values.canton, 10),
      cod_distrito: parseInt(values.distrito, 10),
      cod_mesa: parseInt(values.jrv, 10),
      num_cedula: parseInt(values.cedula, 10),
      cod_puesto: values.role,
      des_usuario: parseInt(userLogged.num_cedula, 10),
      fec_digitado: null,
      cod_periodo: null,
    };

    const userData = {
      codUsuario: userLogged.num_cedula,
    };

    const phoneData = {
      tel_celu: values.celular,
    };

    const emailData = {
      des_email: values.email,
    };

    const dataSet = {
      miembro: memberData,
      usuario: userData,
      telefonos: phoneData,
      emails: emailData,
      isUpdate: 0,
    };

    const jrvVal = parseInt(values.jrv, 10);
    const puesto = values.role;
    const cedUser = parseInt(userLogged.num_cedula, 10);
    miembrosMesaApi
      .validateIfExist(jrvVal, puesto, cedUser)
      .then(r => {
        const existencia = r.data.response;

        if (existencia >= 1) {
          setMsjDialog(
            'En la JRV seleccionada ya se registró una persona en ese puesto. Por favor verifique.',
          );
          setOpenDialog2(true);
        } else {
          miembrosMesaApi
            .submitMiembroMesa(dataSet)
            .then(_response => {
              setIsSaving(false);

              if (
                _response.status === 200 &&
                _response.data.response === 1
              ) {
                setOpenDialog(true);
              } else {
                // eslint-disable-next-line no-console
                console.warn(
                  'No se pudo completar la operacion, vuelva a intentar',
                );
              }
            });
        }
      });
  };

  useEffect(() => {
    if (decodedToken !== null) {
      setUser(decodedToken);
      
      // Configurar provincia inicial con el valor del token
      if (decodedToken.cod_provincia) {
        const provinciaToken = parseInt(decodedToken.cod_provincia, 10);
        setInitialValues(prev => ({
          ...prev,
          provincia: provinciaToken
        }));
        
        // Buscar el objeto completo de la provincia
        const provinciaObj = Lodash.find(provincias, {
          value: provinciaToken,
        });
        setSProvincia(provinciaObj || { value: provinciaToken });
        
        // Cargar cantones de la provincia del token
        if (provinciaToken !== 9) {
          getCantonsByProvince(provinciaToken).then(result => {
            if (result.status === 200) {
              const cantonsList = Lodash.get(result, [
                'data',
                'response',
              ]);
              const clist = cantonsList.map(
                ({ cod_canton, des_nombre_c }) => {
                  return {
                    itemLabel: des_nombre_c,
                    value: cod_canton,
                  };
                },
              );
              clist.unshift({
                itemLabel: '- SELECCIONE EL CANTÓN-',
                value: 999,
              });
              setCantones(clist);
              
              // Configurar cantón inicial con el valor del token
              if (decodedToken.cod_canton) {
                const cantonToken = parseInt(decodedToken.cod_canton, 10);
                setInitialValues(prev => ({
                  ...prev,
                  canton: cantonToken
                }));
                
                // Buscar el objeto completo del cantón
                const cantonObj = { value: cantonToken };
                setSCanton(cantonObj);
                
                // Cargar distritos del cantón del token
                getDistritoByTwo(provinciaToken, cantonToken).then(distResult => {
                  if (distResult.status === 200) {
                    const distritosList = Lodash.get(distResult, [
                      'data',
                      'response',
                    ]);
                    const dlist = distritosList.map(
                      ({ cod_distrito, des_nombre_d }) => {
                        return {
                          itemLabel: des_nombre_d,
                          value: cod_distrito,
                        };
                      },
                    );
                    dlist.unshift({
                      itemLabel: '- SELECCIONE EL DISTRITO-',
                      value: 999,
                    });
                    setDistritos(dlist);
                  }
                });
              }
            }
          });
        }
      }
    }

    buildRolesDropdown();
  }, [decodedToken]);

  /**
   * Form validations
   * @param {*} values
   */
  const formikValidate = values => {
    const errors = {};
    // eslint-disable-next-line no-shadow
    const { celular, email, distrito, jrv, role } = values;

    if (!celular) {
      errors.celular = 'Requerido';
    } else if (!/^[0-9]{8}$/.test(celular)) {
      errors.celular = 'Ejemplo de formato: xxxxxxxx.';
    }

    if (!email) {
      errors.email = 'Requerido';
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
        email,
      )
    ) {
      errors.email = 'Email inválido';
    }

    if (distrito === 999) {
      errors.distrito = 'Seleccione un distrito';
    }

    if (jrv === 999) {
      errors.jrv = 'Seleccione la Junta Receptora';
    }

    if (role === 999) {
      errors.role = 'Seleccione un puesto';
    }

    return errors;
  };

  const closeDialogHandler = () => {
    history.push('/miembros-mesa');
    setOpenDialog(false);
  };

  if (!miembrosMesaAvailable) {
    return (
      <React.Fragment>
        <>
          <Container
            maxWidth="lg"
            className={classes.container}
            style={{
              textAlign: 'center',
            }}
          >
            <h3>AGREGAR MIEMBROS DE MESA</h3>
            <Grid
              container
              spacing={3}
              style={{ marginTop: 20 }}
            >
              <Grid
                item
                xs={12}
                style={{
                  textAlign: 'center',
                  backgroundColor: '#FFE599',
                  color: '#FF9326',
                }}
              >
                <h4>
                  Esta sección se encuentra temporalmente
                  deshabilitada. <br />
                  Favor comunicarse al teléfono 2546-5519 o
                  al correo electorales@plndigital.com
                </h4>
              </Grid>
            </Grid>
          </Container>
        </>
      </React.Fragment>
    );
  }
    
  return (
    <Container maxWidth="lg" className={classes.container}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper className={classes.paper}>
            <Typography
              component="h2"
              variant="h6"
              color="primary"
              gutterBottom
            >
              Nuevo Registro de Miembro de Mesa
              <Button
                variant="contained"
                color="primary"
                size="small"
                className={classes.btnBack}
                onClick={() => {
                  history.push('/miembros-mesa');
                }}
              >
                <ArrowBackIcon /> Regresar
              </Button>
            </Typography>
            <Formik
              validate={formikValidate}
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={saveMember}
            >
              {formik => (
                <form
                  onSubmit={formik.handleSubmit}
                  noValidate
                >
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={3}>
                      <h4># Cédula:</h4>
                      <Field
                        mask="999999999"
                        name="cedula"
                        component={PlnInput}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={3}
                      className={classes.searchContainer}
                    >
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        disabled={searchBtnEnabled}
                        className={classes.btnSearch}
                        onClick={async () => {
                          await getDataByCed(formik);
                        }}
                      >
                        {searchBtnLabel}
                      </Button>
                    </Grid>
                  </Grid>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={3}>
                      {!isNewMemberValid ? (
                        <div className={classes.formError}>
                          <Alert severity="error">
                            {validMemberMsj}
                          </Alert>
                        </div>
                      ) : null}
                    </Grid>
                  </Grid>
                  <Divider style={{ marginTop: 10 }} />
                  {showForm ? (
                    <>
                      <Grid
                        container
                        spacing={3}
                        style={{ marginTop: 20 }}
                      >
                        <Grid item xs={12} sm={3}>
                          <h4
                            className={classes.fieldTitle}
                          >
                            1er. Apellido
                          </h4>
                          <div
                            className={classes.fieldFilled}
                          >
                            {memberInfo.primerApellido}
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                          <h4
                            className={classes.fieldTitle}
                          >
                            2do. Apellido
                          </h4>
                          <div
                            className={classes.fieldFilled}
                          >
                            {memberInfo.segundoApellido}
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                          <h4
                            className={classes.fieldTitle}
                          >
                            Nombre
                          </h4>
                          <div
                            className={classes.fieldFilled}
                          >
                            {memberInfo.nombre}
                          </div>
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={5}>
                          <h4># Celular:</h4>
                          <Field
                            mask="99999999"
                            name="celular"
                            data={memberInfo.celular}
                            component={PlnInput}
                          />
                          {formik.errors.celular &&
                          formik.touched.celular ? (
                            <div
                              className={classes.formError}
                            >
                              <Alert severity="error">
                                {formik.errors.celular}
                              </Alert>
                            </div>
                          ) : null}
                        </Grid>
                        <Grid item xs={12} sm={5}>
                          <h4>Correo Principal:</h4>
                          <Field
                            type="email"
                            name="email"
                            data={memberInfo.email}
                            component={PlnInput}
                          />
                          {formik.errors.email &&
                          formik.touched.email ? (
                            <div
                              className={classes.formError}
                            >
                              <Alert severity="error">
                                {formik.errors.email}
                              </Alert>
                            </div>
                          ) : null}
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={4}>
                          <h4
                            className={classes.fieldTitle}
                          >
                            Provincia
                          </h4>
                          <div>
                            <Field
                              name="provincia"
                              data={provincias}
                              component={PlnDropdown}
                              disabled={true}
                              onChange={provincia => {
                                setProvincia(provincia);
                                formik.setFieldValue(
                                  'canton',
                                  999,
                                );
                                formik.setFieldValue(
                                  'distrito',
                                  999,
                                );
                              }}
                            />
                            {formik.errors.distrito &&
                            formik.touched.distrito ? (
                              <div
                                className={
                                  classes.formError
                                }
                              >
                                <Alert severity="error">
                                  {formik.errors.distrito}
                                </Alert>
                              </div>
                            ) : null}
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <h4
                            className={classes.fieldTitle}
                          >
                            Cantón
                          </h4>
                          <div>
                            <Field
                              name="canton"
                              data={cantones}
                              component={PlnDropdown}
                              disabled={true}
                              onChange={canton => {
                                setCanton(canton);
                                formik.setFieldValue(
                                  'distrito',
                                  999,
                                );
                              }}
                            />
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <h4
                            className={classes.fieldTitle}
                          >
                            Distrito
                          </h4>
                          <div>
                            <Field
                              name="distrito"
                              data={distritos}
                              component={PlnDropdown}
                              onChange={dist => {
                                getJRV(dist);
                              }}
                            />
                            {formik.errors.distrito &&
                            formik.touched.distrito ? (
                              <div
                                className={
                                  classes.formError
                                }
                              >
                                <Alert severity="error">
                                  {formik.errors.distrito}
                                </Alert>
                              </div>
                            ) : null}
                          </div>
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={5}>
                          <h4
                            className={classes.fieldTitle}
                            style={{ marginTop: 0 }}
                          >
                            JRV
                          </h4>
                          <Field
                            name="jrv"
                            data={jrv}
                            component={PlnDropdown}
                            onChange={jrvItem =>
                              getJRVSelected(jrvItem)
                            }
                          />
                          {formik.errors.jrv &&
                          formik.touched.jrv ? (
                            <div
                              className={classes.formError}
                            >
                              <Alert severity="error">
                                {formik.errors.jrv}
                              </Alert>
                            </div>
                          ) : null}
                        </Grid>
                        <Grid item xs={12} sm={5}>
                          <h4
                            className={classes.fieldTitle}
                            style={{ marginTop: 0 }}
                          >
                            Puesto
                          </h4>
                          <Field
                            name="role"
                            data={roles}
                            component={PlnDropdown}
                            onChange={role =>
                              getRoleSelected(role)
                            }
                          />
                          {formik.errors.role &&
                          formik.touched.role ? (
                            <div
                              className={classes.formError}
                            >
                              <Alert severity="error">
                                {formik.errors.role}
                              </Alert>
                            </div>
                          ) : null}
                        </Grid>
                      </Grid>
                      <Grid
                        container
                        spacing={3}
                        style={{ marginTop: 40 }}
                      >
                        <Grid item xs={12}>
                          <Button
                            type="submit"
                            variant="contained"
                            color="secondary"
                            size="small"
                            className={
                              formik.isSubmitting ||
                              isSaving
                                ? classes.btnSubmitting
                                : classes.btnActions
                            }
                            disabled={isSaving}
                          >
                            {isSaving ? (
                              <CircularProgress
                                style={{
                                  width: '30px',
                                  height: '30px',
                                }}
                              />
                            ) : (
                              <>
                                Guardar
                                <SaveIcon
                                  className={
                                    classes.frmIconButton
                                  }
                                />
                              </>
                            )}
                          </Button>
                          <Button
                            type="button"
                            variant="contained"
                            color="secondary"
                            size="small"
                            className={
                              classes.btnActionCancel
                            }
                            onClick={() => {
                              history.push(
                                '/miembros-mesa',
                              );
                            }}
                          >
                            Cancelar
                          </Button>
                        </Grid>
                      </Grid>
                    </>
                  ) : (
                    ''
                  )}
                </form>
              )}
            </Formik>
            <PLNDialog
              open={open}
              onClose={() => {}}
              title="Mensaje"
              bodymessage="Información guardada correctamente."
              buttons={[
                {
                  actionName: 'close',
                  color: 'simple',
                  title: 'Entendido',
                  clickHander: closeDialogHandler,
                },
              ]}
            />
            <Dialog
              open={open2}
              TransitionComponent={Transition}
              keepMounted
              onClose={handleClose}
              aria-labelledby="alert-dialog-slide-title"
              aria-describedby="alert-dialog-slide-description"
            >
              <DialogTitle
                id="alert-confirm-messages"
                color="warning"
              >
                Mensaje
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                  {msjDialog}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={handleClose}
                  color="primary"
                >
                  Entendido
                </Button>
              </DialogActions>
            </Dialog>
          </Paper>
        </Grid>
      </Grid>
      <Box pt={4}>
        <Copyright />
      </Box>
    </Container>
  );
};

export default AddMiembro;
